import { Component, OnInit, inject } from "@angular/core";
import { CardComponent } from "../card/card.component";

@Component({
  selector: "av-card-footer",
  templateUrl: "./card-footer.component.html",
  styleUrls: ["./card-footer.component.scss"],
  standalone: false,
})
export class CardFooterComponent implements OnInit {
  private parent = inject(CardComponent, { optional: true });

  ngOnInit(): void {}

  public get type() {
    return this.parent?.type();
  }
}
